import { CreditCardIcon } from "assets/icons/CreditCardIcon";
import styled from "styled-components";

import { StyledRadioButton } from "../styled";

const StyledContainer = styled.div`
  border: 1px solid #d2d6db;
  border-radius: 8px;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  margin-bottom: 24px;
`;

const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledTitleContainer = styled.div`
  border-bottom: 1px solid #d2d6db;
  i {
    color: #64636e;
    font-size: 14px;
  }
`;

const StyledContentContainer = styled.div`
  padding: 16px;
`;

const StyledFooter = styled.div`
  padding: 10px 16px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #d2d6db;
`;

export function SavedCard({
  savedPaymentMethod,
  showFooter,
  checked,
  radioValue,
  onRadioButtonChange,
}: {
  savedPaymentMethod: any;
  showFooter: boolean;
  checked: boolean;
  radioValue?: number;
  onRadioButtonChange: (e: any) => void;
}) {
  return (
    <StyledContainer>
      <StyledHeader>
        <StyledTitleContainer className="flex align-items-center justify-content-between p-3">
          <div className="flex gap-2 align-items-center">
            <CreditCardIcon
              className="h-auto"
              style={{
                width: "40px",
                minWidth: "40px",
              }}
            />
            Saved Payment Method
          </div>
        </StyledTitleContainer>
      </StyledHeader>
      <StyledContentContainer>
        <div className="flex align-items-center">
          <i
            className={`pi pi-credit-card mr-2 ${
              savedPaymentMethod.brand || savedPaymentMethod.cardDetails?.brand
                ? "text-primary"
                : ""
            }`}
          />
          <div>
            <span className="font-medium">
              {savedPaymentMethod.brand ||
                savedPaymentMethod.cardDetails?.brand ||
                "Card"}{" "}
              ••••{" "}
              {savedPaymentMethod.last4 ||
                savedPaymentMethod.cardDetails?.last4}
            </span>
          </div>
        </div>
      </StyledContentContainer>
      {showFooter && (
        <StyledFooter>
          <p
            className={`text-sm text-center font-normal mb-0 ${
              checked ? "purple" : "gray"
            }`}
          >
            Use this card for future payments
          </p>
          <StyledRadioButton
            inputId="new card"
            name="new-payment"
            value={radioValue}
            checked={checked}
            onChange={onRadioButtonChange}
            width={15}
            height={15}
          />
        </StyledFooter>
      )}
    </StyledContainer>
  );
}
